import { } from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import * as actionTypes from '../constants/sms-chat';

import { updateObject } from '../../../../shared/utils/utility';

import { AppAction } from '../../../../store';

import { ChatsCollection } from '../../models';

export interface SmsChatState {
  chats: ChatsCollection | null;
  chatsError: any | null;
  chatsLoading: boolean;

  localChats: ChatsCollection | null;

  linkToInsuredResult: boolean | null;
  linkToInsuredResultError: any | null;
  linkToInsuredResultLoading: boolean;

  changeChatNameResult: boolean | null;
  changeChatNameResultError: any | null;
  changeChatNameResultLoading: boolean;

  unlinkConversationToInsuredsNotes: boolean | null;
  unlinkConversationToInsuredsNotesError: any | null;
  unlinkConversationToInsuredsNotesLoading: boolean;

  checkExistedChatResult: boolean | null;
  checkExistedChatResultError: any | null;
  checkExistedChatResultLoading: boolean;

  deleteChat: boolean | null;
  deleteChatError: any | null;
  deleteChatLoading: boolean;

  markAsUnreadResult: boolean | null;
  markAsUnreadResultError: any | null;
  markAsUnreadResultLoading: boolean;

  muteNotificationResult: boolean | null;
  muteNotificationResultError: any | null;
  muteNotificationResultLoading: boolean;

  unmuteNotificationResult: boolean | null;
  unmuteNotificationResultError: any | null;
  unmuteNotificationResultLoading: boolean;

  updateChatNamesResult: boolean | null;
  updateChatNamesResultError: any | null;
  updateChatNamesResultLoading: boolean;

  markAsStarred: boolean | null;
  markAsStarredError: any | null;
  markAsStarredLoading: boolean;

  markAsReadResult: boolean | null;
  markAsReadResultError: any | null;
  markAsReadResultLoading: boolean;
}

const initialState: SmsChatState = {
  chats: null,
  chatsError: null,
  chatsLoading: false,

  localChats: null,

  linkToInsuredResult: null,
  linkToInsuredResultError: null,
  linkToInsuredResultLoading: false,

  changeChatNameResult: null,
  changeChatNameResultError: null,
  changeChatNameResultLoading: false,

  unlinkConversationToInsuredsNotes: null,
  unlinkConversationToInsuredsNotesError: null,
  unlinkConversationToInsuredsNotesLoading: false,

  checkExistedChatResult: null,
  checkExistedChatResultError: null,
  checkExistedChatResultLoading: false,

  deleteChat: null,
  deleteChatError: null,
  deleteChatLoading: false,

  markAsUnreadResult: null,
  markAsUnreadResultError: null,
  markAsUnreadResultLoading: false,

  muteNotificationResult: null,
  muteNotificationResultError: null,
  muteNotificationResultLoading: false,

  unmuteNotificationResult: null,
  unmuteNotificationResultError: null,
  unmuteNotificationResultLoading: false,

  updateChatNamesResult: null,
  updateChatNamesResultError: null,
  updateChatNamesResultLoading: false,

  markAsStarred: null,
  markAsStarredError: null,
  markAsStarredLoading: false,

  markAsReadResult: null,
  markAsReadResultError: null,
  markAsReadResultLoading: false,
};

const getChatsStart = (state: SmsChatState, action: AppAction<ChatsCollection>) => {
  return updateObject(state, {
    chatsError: null,
    chatsLoading: true,
  });
};

const getChatsSuccess = (state: SmsChatState, action: AppAction<ChatsCollection>) => {
  return updateObject(state, {
    chats: action.data,
    chatsError: null,
    chatsLoading: false,
  });
};

const getChatsFail = (state: SmsChatState, action: AppAction<ChatsCollection>) => {
  return updateObject(state, {
    chats: null,
    chatsError: action.error,
    chatsLoading: false,
  });
};

const setChats = (state: SmsChatState, action: AppAction<ChatsCollection>) => {
  return updateObject(state, {
    chats: action.data,
  });
};

const setLocalChats = (state: SmsChatState, action: AppAction<ChatsCollection>) => {
  return updateObject(state, {
    localChats: action.data,
  });
};

const linkToInsuredStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    linkToInsuredResultError: null,
    linkToInsuredResultLoading: true,
  });
};

const linkToInsuredSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    linkToInsuredResult: action.data,
    linkToInsuredResultError: null,
    linkToInsuredResultLoading: false,
  });
};

const linkToInsuredFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    linkToInsuredResult: null,
    linkToInsuredResultError: action.error,
    linkToInsuredResultLoading: false,
  });
};

const changeChatNameStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    changeChatNameResultError: null,
    changeChatNameResultLoading: true,
  });
};

const changeChatNameSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    changeChatNameResult: action.data,
    changeChatNameResultError: null,
    changeChatNameResultLoading: false,
  });
};

const changeChatNameFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    changeChatNameResult: null,
    changeChatNameResultError: action.error,
    changeChatNameResultLoading: false,
  });
};

const unlinkConversationToInsuredsNotesStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    unlinkConversationToInsuredsNotesError: null,
    unlinkConversationToInsuredsNotesLoading: true,
  });
};

const unlinkConversationToInsuredsNotesSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    unlinkConversationToInsuredsNotes: action.data,
    unlinkConversationToInsuredsNotesError: null,
    unlinkConversationToInsuredsNotesLoading: false,
  });
};

const unlinkConversationToInsuredsNotesFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    unlinkConversationToInsuredsNotes: null,
    unlinkConversationToInsuredsNotesError: action.error,
    unlinkConversationToInsuredsNotesLoading: false,
  });
};

const checkExistedChatStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    checkExistedChatResultError: null,
    checkExistedChatResultLoading: true,
  });
};

const checkExistedChatSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    checkExistedChatResult: action.data,
    checkExistedChatResultError: null,
    checkExistedChatResultLoading: false,
  });
};

const checkExistedChatFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    checkExistedChatResult: null,
    checkExistedChatResultError: action.error,
    checkExistedChatResultLoading: false,
  });
};

const deleteChatStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    deleteChatError: null,
    deleteChatLoading: true,
  });
};

const deleteChatSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    deleteChat: action.data,
    deleteChatError: null,
    deleteChatLoading: false,
  });
};

const deleteChatFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    deleteChat: null,
    deleteChatError: action.error,
    deleteChatLoading: false,
  });
};

const markAsUnreadStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsUnreadResult: null,
    markAsUnreadResultError: null,
    markAsUnreadResultLoading: true,
  });
};

const markAsUnreadSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsUnreadResult: action.data,
    markAsUnreadResultError: null,
    markAsUnreadResultLoading: false,
  });
};

const markAsUnreadFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsUnreadResult: null,
    markAsUnreadResultError: action.error,
    markAsUnreadResultLoading: false,
  });
};

const muteNotificationStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    muteNotificationResult: null,
    muteNotificationResultError: null,
    muteNotificationResultLoading: true,
  });
};

const muteNotificationSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    muteNotificationResult: action.data,
    muteNotificationResultError: null,
    muteNotificationResultLoading: false,
  });
};

const muteNotificationFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    muteNotificationResult: null,
    muteNotificationResultError: action.error,
    muteNotificationResultLoading: false,
  });
};

const unmuteNotificationStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    unmuteNotificationResult: null,
    unmuteNotificationResultError: null,
    unmuteNotificationResultLoading: true,
  });
};

const unmuteNotificationSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    unmuteNotificationResult: action.data,
    unmuteNotificationResultError: null,
    unmuteNotificationResultLoading: false,
  });
};

const unmuteNotificationFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    unmuteNotificationResult: null,
    unmuteNotificationResultError: action.error,
    unmuteNotificationResultLoading: false,
  });
};

const updateChatNamesStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    updateChatNamesResult: null,
    updateChatNamesResultError: null,
    updateChatNamesResultLoading: true,
  });
};

const updateChatNamesSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    updateChatNamesResult: action.data,
    updateChatNamesResultError: null,
    updateChatNamesResultLoading: false,
  });
};

const updateChatNamesFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    updateChatNamesResult: null,
    updateChatNamesResultError: action.error,
    updateChatNamesResultLoading: false,
  });
};

const markAsStarredStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsStarred: null,
    markAsStarredError: null,
    markAsStarredLoading: true,
  });
};

const markAsStarredSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsStarred: action.data,
    markAsStarredError: null,
    markAsStarredLoading: false,
  });
};

const markAsStarredFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsStarred: null,
    markAsStarredError: action.error,
    markAsStarredLoading: false,
  });
};

const markAsReadStart = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsReadResult: null,
    markAsReadResultError: null,
    markAsReadResultLoading: true,
  });
};

const markAsReadSuccess = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsReadResult: action.data,
    markAsReadResultError: null,
    markAsReadResultLoading: false,
  });
};

const markAsReadFail = (state: SmsChatState, action: AppAction<boolean>) => {
  return updateObject(state, {
    markAsReadResult: null,
    markAsReadResultError: action.error,
    markAsReadResultLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.SMS_CHAT_GET_CHATS_START:
      return getChatsStart(state, action as AppAction<ChatsCollection>);
    case actionTypes.SMS_CHAT_GET_CHATS_SUCCESS:
      return getChatsSuccess(state, action as AppAction<ChatsCollection>);
    case actionTypes.SMS_CHAT_GET_CHATS_FAIL:
      return getChatsFail(state, action as AppAction<ChatsCollection>);

    case actionTypes.SMS_CHAT_SET_CHATS:
      return setChats(state, action as AppAction<ChatsCollection>);

    case actionTypes.SMS_CHAT_SET_LOCAL_CHATS:
      return setLocalChats(state, action as AppAction<ChatsCollection>);

    case actionTypes.SMS_CHAT_LINK_TO_INSURED_START:
      return linkToInsuredStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_LINK_TO_INSURED_SUCCESS:
      return linkToInsuredSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_LINK_TO_INSURED_FAIL:
      return linkToInsuredFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_CHANGE_CHAT_NAME_START:
      return changeChatNameStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_CHANGE_CHAT_NAME_SUCCESS:
      return changeChatNameSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_CHANGE_CHAT_NAME_FAIL:
      return changeChatNameFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_START:
      return checkExistedChatStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_SUCCESS:
      return checkExistedChatSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_CHECK_EXISTED_CHAT_FAIL:
      return checkExistedChatFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_DELETE_CHAT_START:
      return deleteChatStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_DELETE_CHAT_SUCCESS:
      return deleteChatSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_DELETE_CHAT_FAIL:
      return deleteChatFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_START:
      return unlinkConversationToInsuredsNotesStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_SUCCESS:
      return unlinkConversationToInsuredsNotesSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_UNLINK_CONVERSATION_FROM_INSUREDS_NOTES_FAIL:
      return unlinkConversationToInsuredsNotesFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_MARK_AS_UNREAD_START:
      return markAsUnreadStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_MARK_AS_UNREAD_SUCCESS:
      return markAsUnreadSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_MARK_AS_UNREAD_FAIL:
      return markAsUnreadFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_MUTE_NOTIFICATION_START:
      return muteNotificationStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_MUTE_NOTIFICATION_SUCCESS:
      return muteNotificationSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_MUTE_NOTIFICATION_FAIL:
      return muteNotificationFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_UNMUTE_NOTIFICATION_START:
      return unmuteNotificationStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_UNMUTE_NOTIFICATION_SUCCESS:
      return unmuteNotificationSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_UNMUTE_NOTIFICATION_FAIL:
      return unmuteNotificationFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_UPDATE_CHAT_NAMES_START:
      return updateChatNamesStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_UPDATE_CHAT_NAMES_SUCCESS:
      return updateChatNamesSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_UPDATE_CHAT_NAMES_FAIL:
      return updateChatNamesFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_MARK_AS_STARRED_START:
      return markAsStarredStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_MARK_AS_STARRED_SUCCESS:
      return markAsStarredSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_MARK_AS_STARRED_FAIL:
      return markAsStarredFail(state, action as AppAction<boolean>);

    case actionTypes.SMS_CHAT_MARK_AS_READ_START:
      return markAsReadStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_MARK_AS_READ_SUCCESS:
      return markAsReadSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_CHAT_MARK_AS_READ_FAIL:
      return markAsReadFail(state, action as AppAction<boolean>);

    default:
      return state;
  }
};

export default reducer;
